import { Staff } from './Staff';

export class Recruiter extends Staff {}
